import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

interface DnsRouteMapping {
  hostname: string;
  redirectPath: string;
}

@Injectable({
  providedIn: 'root'
})
export class DnsRedirectGuard implements CanActivate {

  private readonly dnsRouteMappings: DnsRouteMapping[] = [
    { hostname: 'gerenciamento.imap.org.br', redirectPath: '/adm/certificados' },
    { hostname: 'controlador.imap.org.br', redirectPath: '/controlador' },
    { hostname: 'abastecimento.imap.org.br', redirectPath: '/abastecimento' },
  ];

  constructor(private router: Router) {}

  /**
   * Retorna o path de redirecionamento baseado no hostname atual.
   * Se não houver mapeamento, retorna o defaultPath.
   */
  getRedirectPath(defaultPath: string = '/adm/home'): string {
    const currentHostname = window.location.hostname.toLowerCase();
    
    const mapping = this.dnsRouteMappings.find(
      m => m.hostname.toLowerCase() === currentHostname
    );

    return mapping ? mapping.redirectPath : defaultPath;
  }

  canActivate(): boolean | UrlTree {
    const currentHostname = window.location.hostname.toLowerCase();
    
    const mapping = this.dnsRouteMappings.find(
      m => m.hostname.toLowerCase() === currentHostname
    );

    if (mapping) {
      return this.router.parseUrl(mapping.redirectPath);
    }

    // Se não houver mapeamento específico, permite a navegação normal
    return true;
  }
}
